/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Sc_SubmitInputs */

const en_mk_tut_sc_submit = /** @type {(inputs: Mk_Tut_Sc_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send a comment, or approve the selected request`)
};

const id_mk_tut_sc_submit = /** @type {(inputs: Mk_Tut_Sc_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim komentar, atau setujui approval yang terpilih`)
};

/**
* | output |
* | --- |
* | "Send a comment, or approve the selected request" |
*
* @param {Mk_Tut_Sc_SubmitInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_sc_submit = /** @type {((inputs?: Mk_Tut_Sc_SubmitInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Sc_SubmitInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_sc_submit(inputs)
	return en_mk_tut_sc_submit(inputs)
});